let coAudioContextObj = window.AudioContext || window.webkitAudioContext || false;
let coAudioContext = new coAudioContextObj();
coAudioContext.suspend();

class CoPlayer {
	//===== Table of Contents =====
	// Load Audio
	// Seek/Scrub
	// Loops
	// Volume/Pan
	// Time Stretch/Pitch Shift
	// Buttons
	// Player Settings

	constructor() {
		this.Kali = new Kali(2);
		
		this.context = coAudioContext;
		unmute(this.context);

		this.message = document.getElementById('coplayer-message');
		this.progressBar = document.getElementById('coplayer-progress-bar');

		this.rate = 1;
		this.previousRate = 1;
		this.offsetRate = 1;
		this.proposedRate = false;

		this.pitch = 0;
		this.previousPitch = 0;
		this.proposedPitch = false;

		this.adjustedRate = 1;
		this.previousAdjustedRate = 1;

		this.numChannels = 2;
		this.isPlaying = false;
		this.audioLoadedBuffer = false;
		this.audioBuffers = [];
		this.outputBuffer = null;
		this.source = null;
		this.outputs = [];
		this.trackProcessed = false;

		this.seekPosition = 0;
		this.contextOffset = 0;
		this.previousDuration = 0;
		this.realDuration = 0;

		this.loopStart = 0;
		this.loopEnd = 1;
		this.loopActive = false;

		this.mergerNode = false;
		this.splitterNode = false;

		// this.gainMultiplier = 0.8;
		this.gainMultiplier = 1;
		this.monoGainMultiplier = 1;
		this.panValue = 0;
		this.monoOrStereo = 'stereo';
		this.flipChannels = 'normal';

		this.autoplay = 'off';
		this.shuffle = 'off';

		this.adjTimer;

		this.colorMode = 'dark';
		this.playerMode = 'simple';

		this.volumeNodes = [];

		this.player = document.getElementById('coplayer');

		this.playPauseButton = document.getElementById('coplayer-play-pause');

		this.audioElement = document.getElementById('coplayer-audio');
		this.audioElement.crossOrigin = 'anonymous';

		this.seekElement = document.getElementById('coplayer-seek');
		this.trackLength = document.getElementById('coplayer-track-length');
		this.currentTime = document.getElementById('coplayer-current-time');
		this.trackDuration = 0;

		this.loopOverlay = document.getElementById('coplayer-loop-overlay');

		this.stretchLoopProcessing = false;

		this.loadPlayerSettings();

		this.adjustmentColors = {
			'Pitch': 'red',
			'Speed': 'coral',
			'Pan': 'green',
			'Balance': 'blue',
			'Flipped': 'purple',
			'Stretching': 'teal',
			'Button': 'dodgerblue',
			'Volume': 'darksalmon',
			'Seek Position': 'magenta'
		}

		this.headerColors = {
			'player': '#666',
			'audio': 'orangered',
			'playerSettings': 'mediumvioletred',
			'trackSettings': 'cornflowerblue',
			'trackData': 'violet'
		}

		this.playerSettings = [
			'colorMode',
			'playerMode',
			'gainMultiplier',
			'monoOrStereo',
			'autoplay',
			'shuffle'
		];

		this.trackSettings = [
			'rate',
			'pitch',
			'flipChannels',
			'loopStart',
			'loopEnd',
			'loopActive',
			'panValue'
		];

		this.headerConsoleStyle = 'padding: 6px 12px; color: white';
		console.log('%c' + 'ChoralOrg - COPlayer', 'background: ' + this.headerColors.player + '; ' + this.headerConsoleStyle);
	}

	reportAdjustment(value, title, color) {
		console.log('%c' + title + ': %c' + value, '', 'color: ' + color);
	}


	//===========================
	// Load Audio
	//===========================	
	loadAudio(url, callback) {
		this.player.classList.add('loading');
		this.trackProcessed = false;

		let request = new XMLHttpRequest();
		request.open('GET', url, true);
		request.responseType = 'arraybuffer';

		let obj = this;
		request.onload = function() {
			console.log('%c' + 'Audio Loaded', 'background: ' + obj.headerColors.audio + '; ' + obj.headerConsoleStyle);
			console.log(url);
			obj.context.decodeAudioData(request.response, callback);
		};
		request.send();		
	}

	afterLoadAudio(audioLoadedBuffer, wasPlaying) {
		this.outputBuffer = audioLoadedBuffer;
		this.previousDuration = this.outputBuffer.duration;

		this.trackDuration = this.outputBuffer.duration;

		this.adjustTimes(0);
		this.splitterNode = new ChannelSplitterNode(this.context, {numberOfOutputs: this.numChannels});
		this.mergerNode = new ChannelMergerNode(this.context, {numberOfOutputs: this.numChannels});
		// this.source.connect(this.splitterNode);

		let destination;
		for(let i = 0; i < this.numChannels; i++) {
			destination = this.outputBuffer.numberOfChannels == 1 ? 0 : i;

			this.volumeNodes[i] = new GainNode(this.context);
			this.splitterNode.connect(this.volumeNodes[i], destination);
			this.volumeNodes[i].gain.value = Math.sqrt(.5);
		}

		console.log(this);
		this.changeNumChannels();
		this.mergerNode.connect(this.context.destination);

		for(let i = 0; i < this.numChannels; i++) {
			destination = this.outputBuffer.numberOfChannels == 1 ? 0 : i;
			
			this.audioBuffers[i] = audioLoadedBuffer.getChannelData(destination);
		}

		document.addEventListener('touchstart', function(){

		});
	}


	//===========================
	// Seek/Scrub
	//===========================	
	changeSeekPoint(percentage) {
		let wasPlaying = this.isPlaying;

		this.pause();

		this.resetScrubber(percentage);

		if(this.isOutsideLoopBounds(percentage)) coPlayerControls.updateLoopStatus('off');

		//Start player again
		this.restartPlayer(wasPlaying);
	}

	resetScrubber(percentage) {
		//Reset times
		this.contextOffset = this.context.currentTime - parseFloat(percentage) * this.previousDuration;
		this.offsetRate = this.rate;

		this.seekElement.value = percentage;
	}

	getAdjustedPercentage(includeCurrentTime) {
		let adjustedPercentage = (this.context.currentTime - this.contextOffset) / this.previousDuration * this.getPitchPercentChange();

		this.adjustTimes(adjustedPercentage);

		return adjustedPercentage;
	}

	getSeekPosition(command) {
		console.log('%c' + command.capitalize(), 'color: ' + this.adjustmentColors['Button']);

		this.seekPosition = this.getAdjustedPercentage();
		if(command == 'stop') {
			this.seekPosition = 0;
			this.contextOffset = this.context.currentTime;
			this.offsetRate = this.rate;
		}

		if(command == 'stop' || command == 'pause') {
			if(this.isPlaying === false) return false;
			this.isPlaying = false;
			this.context.suspend();
		} else if(command == 'play') {
			if(this.isPlaying === true) return false;
			this.isPlaying = true;
			this.context.resume();
		}
	}

	getStartPoint() {
		this.realDuration = this.outputBuffer.duration / this.getPitchPercentChange();
		this.previousDuration = this.realDuration;

		return this.seekPosition * this.realDuration;
	}

	zeroPad(num) {
		var zero = 2 - num.toString().length + 1;
		return Array(+(zero > 0 && zero)).join("0") + num;		
	}

	convertToTime(duration) {
		let mins = Math.floor(duration / 60);
		let secs = Math.floor(duration % 60);

		if(!duration) {
			mins = 0;
			secs = 0;
		}

		return mins + ':' + this.zeroPad(secs);
	}

	adjustTimes(percentage) {
		this.currentTime.innerHTML = this.convertToTime(this.trackDuration * percentage);
		this.trackLength.innerHTML = this.convertToTime(this.trackDuration);
	}

	changeSeekMarker() {
		let adjustedPercentage = this.getAdjustedPercentage(true);
		
		adjustedPercentage /= this.getPitchPercentChange();

		//If outside loop area on 
		if(this.isOutsideLoopBounds(adjustedPercentage)) {
			adjustedPercentage = parseFloat(this.loopStart);
			this.resetScrubber(adjustedPercentage);
		}

		this.seekElement.value = adjustedPercentage;

		let adjustmentType = 'Seek Position';
		let adjustmentValue = adjustedPercentage;
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);

		if(adjustedPercentage >= 1) this.endOfTrack();
	}


	//===========================
	// Loops
	//===========================
	setLoop(loopSide) {
		//Set JS value
		this[loopSide] = this.seekElement.value;

		//Correct if loopEnd is before loopStart
		if(this.loopEnd <= this.loopStart) {
			if(loopSide !== 'loopStart') this.loopStart = 0;
			if(loopSide !== 'loopEnd') this.loopEnd = 1;
		}

		//Update overlay style
		this.loopOverlay.style.left = parseFloat(this.loopStart) * 100 + '%';
		this.loopOverlay.style.width = parseFloat(this.getLoopLength()) * 100 + '%';

		coPlayerControls.updateLoopStatus('on');

		this.updateLoopStart(false);
	}

	getLoopLength() {
		return parseFloat(this.loopEnd) - parseFloat(this.loopStart);
	}

	updateLoopStart(isChange) {
		if(this.source !== null) {
			this.source.loopStart = parseFloat(this.loopStart) * this.source.buffer.duration;
			this.source.loopEnd = parseFloat(this.loopEnd) * this.source.buffer.duration;
			this.source.loop = this.loopActive;

			if(this.loopActive === true && isChange === true) {
				let percentage = this.getAdjustedPercentage(true) / this.getPitchPercentChange();
				if(this.isOutsideLoopBounds(percentage)) {
					let wasPlaying = this.isPlaying;
					this.pause();
					this.resetScrubber(parseFloat(this.loopStart));
					this.restartPlayer(wasPlaying);
				}
			}
		}
	}

	isOutsideLoopBounds(percentage) {
		return((percentage > this.loopEnd || percentage < this.loopStart) && this.loopActive === true);
	}


	//===========================
	// Volume/Pan
	//===========================
	changeNumChannels(monoOrStereo, flipChannels) {
		console.log(monoOrStereo !== void 0);
		console.log(monoOrStereo !== void 0, undefined);

		if(monoOrStereo !== void 0) this.monoOrStereo = monoOrStereo;
		if(flipChannels !== void 0) this.flipChannels = flipChannels;

		if(this.monoOrStereo === undefined) this.monoOrStereo = 'stereo';
		if(this.flipChannels === undefined) this.flipChannels = 'normal';

		let adjustmentType = 'Pan';
		let adjustmentValue = this.monoOrStereo.capitalize();
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);

		adjustmentType = 'Flipped';
		adjustmentValue = this.flipChannels.capitalize();
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);

		for(let i = 0; i < this.numChannels; i++) {
			try {
				this.volumeNodes[i].disconnect(this.mergerNode);
			} catch(exception) {}
		}

		this.monoGainMultiplier = this.monoOrStereo == 'mono' ? Math.sqrt(.5) : 1;
		// this.monoGainMultiplier = this.monoOrStereo == 'mono' ? .5 : 1;

		for(let i = 0; i < this.numChannels; i++) {
			if(this.monoOrStereo == 'stereo') {
				if(this.flipChannels == 'flipped') {
					this.volumeNodes[0].connect(this.mergerNode, 0, 1); //Connect right channel to left speaker
					this.volumeNodes[1].connect(this.mergerNode, 0, 0); //Connect left channel to right speaker
				} else {
					this.volumeNodes[i].connect(this.mergerNode, 0, i); //Connect to respective channel
				}
			} else {
				this.volumeNodes[i].connect(this.mergerNode, 0, 0); //Connect to left channel
				this.volumeNodes[i].connect(this.mergerNode, 0, 1); //Connect to right channel
			}
		}
	}

	changePan(panValue) {
		if(panValue !== void 0) this.panValue = panValue;
		this.adjustPanVolumes(false);
	}

	changeVolume(volumeValue) {
		if(volumeValue !== void 0) this.gainMultiplier = volumeValue;
		this.adjustPanVolumes(true);
		this.savePlayerSettings();
	}

	adjustPanVolumes(isVolume) {
		let absPanValue = Math.abs(this.panValue);

		let louderLevelInput = absPanValue + (1 - absPanValue) / 2;
		let softerLevelInput = 1 - louderLevelInput;
		let louderLevel = this.convertLinearLevelToEqualPower(louderLevelInput);
		let softerLevel = this.convertLinearLevelToEqualPower(softerLevelInput);

		let percentage = 100 * absPanValue;

		console.log(this.applyGainMultipiers(louderLevel))
		console.log(this.applyGainMultipiers(softerLevel))


		let adjustmentType = 'Balance';
		let adjustmentValue;
		if (this.panValue < 0) { //left
			this.volumeNodes[0].gain.value = this.applyGainMultipiers(louderLevel);
			this.volumeNodes[1].gain.value = this.applyGainMultipiers(softerLevel);

			adjustmentValue = 100 * absPanValue + '% Left';
		} else if(this.panValue > 0) { //Right
			this.volumeNodes[0].gain.value = this.applyGainMultipiers(softerLevel);
			this.volumeNodes[1].gain.value = this.applyGainMultipiers(louderLevel);

			adjustmentValue = 100 * absPanValue + '% Right';
		} else { //Balanced
			this.volumeNodes[0].gain.value = this.applyGainMultipiers(softerLevel);
			this.volumeNodes[1].gain.value = this.applyGainMultipiers(louderLevel);

			adjustmentValue = 'Balanced';
		}

		if(isVolume) {
			adjustmentType = 'Volume';
			adjustmentValue = 100 * this.gainMultiplier + '%';
		}
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);
	}

	convertLinearLevelToEqualPower(level) {
		return Math.cos((1 - level) * .5 * Math.PI);
	}

	applyGainMultipiers(gain) {
		return gain * this.gainMultiplier * this.monoGainMultiplier;
	}	


	//===========================
	// Time Stretch/Pitch Shift
	//===========================
	changeRate(rate) {
		if(rate !== void 0) this.proposedRate = rate;

		let adjustmentType = 'Speed';
		let adjustmentValue = this.proposedRate;
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);

		this.makeAudioAdjustments(true, this.isPlaying);
	}

	changePitch(pitch) {
		if(pitch !== void 0) this.proposedPitch = pitch;

		let adjustmentType = 'Pitch';
		let adjustmentValue = this.proposedPitch;
		this.reportAdjustment(adjustmentValue, adjustmentType, this.adjustmentColors[adjustmentType]);

		this.makeAudioAdjustments(true, this.isPlaying);
	}

	makeAudioAdjustments(isRateChange, wasPlaying) {
		let obj = this;

		clearTimeout(this.adjTimer);
		this.adjTimer = setTimeout(function() {

			//Don't process track if values are the same, but process if initial load
			if(obj.trackProcessed) {

				let pitchNotChanged = obj.proposedPitch == obj.pitch || obj.proposedPitch === false;
				let rateNotChanged = obj.proposedRate == obj.rate || obj.proposedRate === false;

				console.log(obj.proposedPitch);
				console.log(obj.pitch);
				console.log(pitchNotChanged);

				console.log(obj.proposedRate);
				console.log(obj.rate);
				console.log(rateNotChanged);

				if(rateNotChanged && pitchNotChanged) return;
			}

			obj.player.classList.add('processing');
			setTimeout(function() {
				obj.trackProcessed = true;

				obj.previousRate = obj.rate;
				obj.rate = obj.proposedRate;

				obj.previousPitch = obj.pitch;
				obj.pitch = obj.proposedPitch;

				obj.setAudioAdjustments(isRateChange, wasPlaying);
			}, 50);
		}, 1250);
	}

	setAudioAdjustments(isRateChange, wasPlaying) {
		this.adjustedRate = this.getAdjustedRate();

		let filename = coPlayerControls.currentTrackAttachmentIdentifier + '__rate_' + this.rate + '__pitch_' + this.pitch + '.dat';

		let data = {
			action: 'coplayer_track_data_exists_ajax',
			filename: filename
		};

		const obj = this;

		postAjax('/wp-admin/admin-ajax.php', data, function(response) {
			// console.log('%c' + 'Track Data Loaded', 'background: ' + obj.headerColors.trackData + '; ' + obj.headerConsoleStyle);
			console.log(response);
			if(response == 1) {
				let progressBar = document.getElementById('coplayer-progress-bar');
				progressBar.style.width = '100%';						

				obj.loadTrackData(coPlayerControls.currentTrackAttachmentIdentifier, isRateChange, wasPlaying);
			} else {
				obj.message.classList.remove('loading');
				obj.message.classList.add('processing');

				for(let i = 0; i < obj.numChannels; i++) {
					obj.doStretch(obj.audioBuffers[i], obj.adjustedRate, 1, i, isRateChange, wasPlaying);
				}
			}
		});
	}

	getPitchPercentChange() {
		return Math.pow(Math.pow(2, 1/12), this.pitch);
	}

	getAdjustedRate() {
		return this.rate / this.getPitchPercentChange();		
	}

	doStretch(inputData, stretchFactor, numChannels, i, isRateChange, wasPlaying) {
		if (numChannels === void 0) numChannels = 1;

		let numInputFrames = inputData.length / numChannels;
		let bufsize = 8192 * numChannels;
		
		// Create a Kali instance and initialize it
		let kali = new Kali(numChannels);
		// let quickProcessing = true;
		let quickProcessing = false;
		kali.setup(44100, stretchFactor, quickProcessing);
		
		// Create an array for the stretched output. Note if the rate is changing, this array won't be completely full
		this.outputs[i] = new Float32Array(Math.floor((numInputFrames / stretchFactor) * numChannels + 1));

		if(true) {
			let progressBarWidth;
			
			var inputOffset = 0;
			var completedOffset = 0;
			var loopCount = 0;
			var flushed = false;
			
			let channel = i == 0 ? 'L' : 'R';

			let adjustmentType = 'Stretching';
			let adjustmentValue;

			let progressBar = document.getElementById('coplayer-progress-bar');

			let stretchPercent;

			let obj = this;

			let stretchTimeout;

			this.stretchLoopProcessing = true;

			function stretchLoop(isRateChange, wasPlaying) {
			// this.stretchLoop = function(isRateChange, wasPlaying) {
			// function stretchLoop(isRateChange, wasPlaying) {
				if(loopCount % 100 == 0) kali.setTempo(stretchFactor);

				// Read stretched samples into our output array
				completedOffset += kali.output(obj.outputs[i].subarray(completedOffset, Math.min(completedOffset + bufsize, obj.outputs[i].length)));
				if(inputOffset < inputData.length) {
					var dataToInput = inputData.subarray(inputOffset, Math.min(inputOffset + bufsize, inputData.length));
					inputOffset += dataToInput.length;
					// Feed Kali samples
					kali.input(dataToInput);
					kali.process();
				} else if(!flushed) {
					kali.flush();
					flushed = true;
				}
				loopCount++;

				if(completedOffset < obj.outputs[i].length) {
					stretchTimeout = setTimeout(function(){
						if(obj.stretchLoopProcessing !== false) stretchLoop(isRateChange, wasPlaying);
					});
				} else {
					if(obj.stretchLoop !== false) {
						adjustmentValue = obj.getStretchPercent(inputOffset, inputData.length);
						obj.reportAdjustment(adjustmentValue, adjustmentType + ' ' + channel, obj.adjustmentColors[adjustmentType]);
						progressBar.style.width = adjustmentValue;						

						//Callback function
						obj.afterDoStretch(i, isRateChange, wasPlaying);
					}
				}

				if(loopCount % 10 == 0) {
					adjustmentValue = obj.getStretchPercent(inputOffset, inputData.length);
					obj.reportAdjustment(adjustmentValue, adjustmentType + ' ' + channel, obj.adjustmentColors[adjustmentType]);
					progressBar.style.width = adjustmentValue;					
				}
			}

			// this.stretchLoop(isRateChange, wasPlaying);
			stretchLoop(isRateChange, wasPlaying);
		}
	}

	afterDoStretch(i, isRateChange, wasPlaying, wasLoadedData = false) {
		this.player.classList.remove('loading');
		this.player.classList.remove('loading-data');
		this.player.classList.remove('processing');

		let obj = this;

		setTimeout(function(){
			if(obj.stretchLoop !== null) {

				obj.outputBuffer = obj.context.createBuffer(2, obj.outputs[i].length, obj.context.sampleRate);

				obj.pause();

				if(i == 1) {
					for(let j = 0; j < obj.numChannels; j++) {
						obj.outputBuffer.getChannelData(j).set(obj.outputs[j]);
					}

					if(obj.source !== null) {
						obj.context.suspend();

						if(isRateChange) {
							obj.source.disconnect(obj.splitterNode);
						}
						obj.source = null;
					}

					if(wasPlaying === true) {
						obj.isPlaying = false;
						obj.play();
						if(isRateChange && obj.loopActive !== true) {
							obj.resetScrubber(obj.seekElement.value);
						} else if(isRateChange) {
							obj.pause();
							obj.resetScrubber(parseFloat(obj.loopStart));
							obj.restartPlayer(wasPlaying);
						}
					}
					if(obj.trackProcessed) {
						if(!wasLoadedData) obj.saveTrackData(coPlayerControls.currentTrackAttachmentIdentifier);
						obj.saveTrackSettings(coPlayerControls.currentTrackAttachmentIdentifier);
					}
				}
			}
		}, 500);
	}

	getStretchPercent(offset, length) {
		let decimalFactor = 100;
		return Math.round(100 * decimalFactor * offset / length) / decimalFactor + '%';
	}


	//==================
	// Buttons
	//==================
	pressPlayPauseButton() {
		if(this.isPlaying === true) {
			this.pause();
		} else {
			this.play();
		}
	}

	togglePlayPauseButton(command) {
		if(command == 'play') {
			this.playPauseButton.classList.remove('play');
			this.playPauseButton.classList.add('pause');			
		} else {
			this.playPauseButton.classList.remove('pause');
			this.playPauseButton.classList.add('play');
		}
	}

	play() {
		this.togglePlayPauseButton('play');
		if(this.getSeekPosition('play') == false) return;

		if(this.source === null) {
			this.source = this.context.createBufferSource(this.audioElement);
			this.source.detune.value = this.pitch * 100;
			this.source.buffer = this.outputBuffer;

			this.source.connect(this.splitterNode);

			this.updateLoopStart(false);

			this.source.start(this.context.currentTime, this.getStartPoint());
		}
	}

	pause() {
		this.togglePlayPauseButton('pause');
		if(this.getSeekPosition('pause') == false) return;
	}

	stop() {
		this.togglePlayPauseButton('pause')
		if(this.getSeekPosition('stop') == false) return;

		this.seekElement.value = 0;

		this.adjustTimes(0);

		this.source.stop(this.context.currentTime);
		this.source.disconnect(this.splitterNode);
		this.source = null;
	}

	restartPlayer(wasPlaying) {
		if(this.source !== null) {
			try {
				this.source.disconnect(this.splitterNode);
			} catch(exception) {
				console.log(exception);
			} finally {
				this.source = null;
				if(wasPlaying === true) {
					this.isPlaying = false;
					this.play();
				}
			}
		}
	}

	endOfTrack() {
		if(this.loopActive !== true) {
			if(this.autoplay == 'on') {
				coPlayerControls.advanceTrackIndex('forward');
			} else if(this.autoplay == 'off') {
				this.stop();
			}
		}
	}

	//==================
	// Track Data
	//==================
	saveTrackData(trackIdentifier) {
		const disableSaving = document.getElementById('disable_data_file_saving');

		if(disableSaving.value != 'on') {
			let filenamePrefix = trackIdentifier + '__rate_' + this.rate + '__pitch_' + this.pitch;

			const blobLeft = new Blob([this.outputs[0]], {type: 'application/octet-stream'});
			const blobRight = new Blob([this.outputs[1]], {type: 'application/octet-stream'});

			console.log(blobLeft);
			console.log(blobRight);

			const data = {
				left: URL.createObjectURL(blobLeft),
				right: URL.createObjectURL(blobRight)
			};

			console.log(data);

			const obj = this;

			blobLeft.arrayBuffer().then((buffer) => {
			    fetch('/wp-content/plugins/coplayer/ajax/save-track-data.php', {
			        method: 'POST',
			        headers: {
			            'Content-Type': blobLeft.type,
			            'Content-Disposition': 'attachment; filename="' + filenamePrefix + '__L.bin"',
			        },
			        body: buffer,
			        filename: filenamePrefix,
			    })
			    .then((response) => response.text())
			    .then((data) => {
			        console.log("Server response:", data);
			    })
			    .catch((error) => {
			        console.error("Error uploading blob:", error);
			    });
			});

			blobRight.arrayBuffer().then((buffer) => {
			    fetch('/wp-content/plugins/coplayer/ajax/save-track-data.php', {
			        method: 'POST',
			        headers: {
			            'Content-Type': blobLeft.type,
			            'Content-Disposition': 'attachment; filename="' + filenamePrefix + '__R.bin"',
			        },
			        body: buffer,
			        filename: filenamePrefix,
			    })
			    .then((response) => response.text())
			    .then((data) => {
			        console.log("Server response:", data);
			    })
			    .catch((error) => {
			        console.error("Error uploading blob:", error);
			    });
			});
		}
	}

	loadTrackData(trackIdentifier, isRateChange, wasPlaying) {
		const filename = trackIdentifier + '__rate_' + this.rate + '__pitch_' + this.pitch + '.dat';

		const dataFolder = document.getElementById('data-folder-path').value;

		//Read data from file 
		let data = { 
			filename: filename 
		}; 
		console.log(filename); 
 
		const obj = this; 
 
		obj.player.classList.remove('loading'); 
		obj.player.classList.add('loading-data'); 
		postAjax('/wp-content/plugins/coplayer/ajax/load-track-data.php', data, function(response) { 
			console.log('%c' + 'Track Data Loaded', 'background: ' + obj.headerColors.trackData + '; ' + obj.headerConsoleStyle); 
			console.log(response); 
			let parsedResponse = JSON.parse(response); 
			parsedResponse[0] = new Float32Array(parsedResponse[0]); 
			parsedResponse[1] = new Float32Array(parsedResponse[1]); 
			obj.outputs = parsedResponse; 
			obj.afterDoStretch(1, isRateChange, wasPlaying, true); 
		}); 


		// fetch(dataFolder + '/' + filename)
		// 	.then((response) => response.text())
		// 	.then(responseText => {
		// 		const compressed = Uint8Array.from(atob(responseText), c => c.charCodeAt(0));
		// 		const decompressed = pako.ungzip(compressed, { to: "string" });

		// 		console.log('%c' + 'Track Data Loaded', 'background: ' + obj.headerColors.trackData + '; ' + obj.headerConsoleStyle);
		// 		// console.log(response);
		// 		let parsedResponse = JSON.parse(decompressed);
		// 		parsedResponse[0] = new Float32Array(parsedResponse[0]);
		// 		parsedResponse[1] = new Float32Array(parsedResponse[1]);
		// 		obj.outputs = parsedResponse;
		// 		obj.afterDoStretch(1, isRateChange, wasPlaying, true);
		// 	}); 
	}


	//==================
	// Player Settings
	//==================
	savePlayerSettings() {
		let playerSettings = {};
		for(let i = 0; i < this.playerSettings.length; i++) {
			playerSettings[this.playerSettings[i]] = this[this.playerSettings[i]];
		}

		let data = {
			action: 'coplayer_save_settings_ajax',
			settings: JSON.stringify(playerSettings)
		};

		let obj = this;
		postAjax('/wp-admin/admin-ajax.php', data, function(response) {
			console.log('%c' + 'Player Settings Saved', 'background: ' + obj.headerColors.playerSettings + '; ' + obj.headerConsoleStyle);
			console.log(JSON.parse(response));
		});
	}

	saveTrackSettings(trackIdentifier) {
		let trackSettings = {};
		for(let i = 0; i < this.trackSettings.length; i++) {
			trackSettings[this.trackSettings[i]] = this[this.trackSettings[i]];
		}

		//Write settings to track div
		let track = document.getElementById('coplayer-playlist-track-' + trackIdentifier);
		track.setAttribute('track_settings', btoa(JSON.stringify(trackSettings)));

		//Write settings to cookie or db
		let data = {
			action: 'coplayer_save_settings_ajax',
			track_identifier: trackIdentifier,
			settings: JSON.stringify(trackSettings)
		};

		let obj = this;
		postAjax('/wp-admin/admin-ajax.php', data, function(response) {
			console.log('%c' + 'Track Settings Saved', 'background: ' + obj.headerColors.trackSettings + '; ' + obj.headerConsoleStyle);
			console.log(JSON.parse(response));
		});
	}

	loadPlayerSettings() {
		let playerSettingsDiv = document.getElementById('coplayer-player-settings');

		let obj = this;

		console.log(JSON.parse(atob(playerSettingsDiv.getAttribute('settings'))));

		if(isJson(atob(playerSettingsDiv.getAttribute('settings')))) {
			let playerSettings = JSON.parse(atob(playerSettingsDiv.getAttribute('settings')));
			setTimeout(function(){
				obj.afterLoadPlayerSettings(playerSettings);
			}, 50);
		} else {
			let data = {
				action: 'coplayer_load_settings_ajax'
			};

			postAjax('/wp-admin/admin-ajax.php', data, function(response) {
				let playerSettings = JSON.parse(response);

				obj.afterLoadPlayerSettings(playerSettings);
			});
		}
	}

	loadTrackSettings(trackIdentifier, audioLoadedBuffer, wasPlaying) {
		let track = document.getElementById('coplayer-playlist-track-' + trackIdentifier);

		let obj = this;

		if(isJson(atob(track.getAttribute('track_settings')))) {
			let trackSettings = JSON.parse(atob(track.getAttribute('track_settings')));
			this.afterLoadTrackSettings(trackSettings, audioLoadedBuffer, wasPlaying);
		} else {
			let data = {
				action: 'coplayer_load_settings_ajax',
				track_identifier: trackIdentifier
			};	
			postAjax('/wp-admin/admin-ajax.php', data, function(response) {
				let trackSettings = JSON.parse(response);
				obj.afterLoadTrackSettings(trackSettings, audioLoadedBuffer, wasPlaying);
			});
		}
	}

	afterLoadPlayerSettings(playerSettings) {
		console.log('%c' + 'Player Settings Loaded', 'background: ' + this.headerColors.playerSettings + '; ' + this.headerConsoleStyle);
		console.log(playerSettings);

		//Load values into properties
		this.loadSettingsIntoProperties(playerSettings, this.playerSettings);

		//Load values into UI components
		this.loadPlayerSettingsUI();	
	}

	afterLoadTrackSettings(trackSettings, audioLoadedBuffer, wasPlaying) {
		this.afterLoadAudio(audioLoadedBuffer, wasPlaying);

		console.log('%c' + 'Track Settings Loaded', 'background: ' + this.headerColors.trackSettings + '; ' + this.headerConsoleStyle);
		console.log(trackSettings);

		//Load values into properties
		this.loadSettingsIntoProperties(trackSettings, this.trackSettings);

		//Load values into UI components
		this.loadTrackSettingsUI();		
	}

	loadPlayerSettingsUI() {
		let buttons = ['autoplay', 'shuffle'];
		for(let i = 0; i < buttons.length; i++) {
			coPlayerControls.setButton(coPlayerControls[buttons[i] + 'Button'], coPlayerControls, ['off', 'on'], this[buttons[i]]);
		}
		coPlayerControls.setButton(coPlayerControls.monoOrStereoCheckbox, coPlayerControls, ['mono', 'stereo'], this.monoOrStereo);
	}

	loadTrackSettingsUI() {
		//Loops
		let loopActive = this.loopActive === true ? 'on' : 'off';
		coPlayerControls.updateLoopStatus(loopActive);
		this.loopOverlay.style.left = parseFloat(this.loopStart) * 100 + '%';
		this.loopOverlay.style.width = parseFloat(this.getLoopLength()) * 100 + '%';
		this.changeSeekPoint(parseFloat(this.loopStart));

		//Adjustment Sliders
		this.loadSliderValue(document.getElementById('coplayer-pitch-slider'), this.pitch);
		this.loadSliderValue(document.getElementById('coplayer-speed-slider'), this.rate);
		this.loadSliderValue(document.getElementById('coplayer-balance-slider'), 100 * this.panValue);

		//Switch Channels
		coPlayerControls.setButton(coPlayerControls.flipChannelsCheckbox, coPlayerControls, ['normal', 'flipped'], this.flipChannels);
	}

	loadSliderValue(slider, value) {
		slider.value = value;
		coPlayerControls.slider(slider, coPlayerControls);		
	}

	loadSettingsIntoProperties(settings, settingList) {
		if(settings !== null) {
			for(let i = 0; i < settingList.length; i++) {
				let key = settingList[i];
				if(settings[key] !== undefined) {
					let floatValue = parseFloat(settings[key]);
					if(!isNaN(floatValue)) {
						this[key] = floatValue;
					} else {
						this[key] = settings[key];
					}
				}
			}
		}
	}

	getCookie(c_name) {
		if (document.cookie.length > 0) {
			let c_start = document.cookie.indexOf(c_name + "=");
			if (c_start != -1) {
				c_start = c_start + c_name.length + 1;
				let c_end = document.cookie.indexOf(";", c_start);
				if (c_end == -1) {
					c_end = document.cookie.length;
				}
				return unescape(document.cookie.substring(c_start, c_end));
			}
		}
		return "";		
	}

}

String.prototype.capitalize = function() {
	return this.charAt(0).toUpperCase() + this.slice(1);
}

let coplayer;
let coPlayerControls;

if(document.getElementById('coplayer') !== null) {
	coplayer = new CoPlayer();
	coPlayerControls = new CoPlayerControls();

	window.setInterval(function(){
		if(coplayer.isPlaying) coplayer.changeSeekMarker();
	}, 100);
}

//Temporarily setup buttons to toggle coplayer class
function toggleClass(className) {
	document.getElementById('coplayer').classList.toggle(className);
}

function toggleClassSample(className) {
	document.getElementById('coplayer-sample').classList.toggle(className);
}

function updateColors(dark, light) {
	let data = {
		action: 'coplayer_update_color_scheme',
		dark: dark,
		light: light
	};

	postAjax('/wp-admin/admin-ajax.php', data, function(response) {
		document.getElementById('coplayer-bg').innerHTML = response;
	});

}

function postAjax(url, data, success) {
	let params = typeof data == 'string' ? data : Object.keys(data).map(
			function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
		).join('&');

	let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	xhr.open('POST', url);
	xhr.onreadystatechange = function() {
		if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
	};
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(params);
	return xhr;
}

function isJson(str) {
    try {
        let parsed = JSON.parse(str);
        console.log(str);
        console.log(parsed == '');
        return parsed != '';
    } catch (e) {
        return false;
    }
    return true;
}
